import { BrowserRouter } from 'react-router-dom';

import { HomeLayout } from '../components/layout';
import { HOME_BASENAME } from '../routing/HomeRoutes';

export const HomeAppProvider = () => (
    <BrowserRouter
        basename={HOME_BASENAME}
        future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}
    >
        <HomeLayout />
    </BrowserRouter>
);
